import { memo, useMemo } from "react";
import { useSelector } from "react-redux";
import { Col, Row, Typography, Skeleton } from "antd";
import { WidgetCard, NoDataText } from "@components/widgets/index";
import { ReactComponent as AiIcon } from "@images/ai_icon.svg";
import { FaBolt } from "react-icons/fa6";
import { keys } from "underscore";
import { showBetaTag } from "@/ts/revstack/ui-utils";
import { ITitle } from "@/ts/common-types";
import BetaBadge from "@components/widgets/BetaBadge";

const { Text } = Typography;

const RevstackAIInsights: React.FC<{ layoutType?: string }> = memo(({ layoutType }) => {
    const isAiInsightsLoading = useSelector((state: any) => state.isAiInsightsLoading.value);
    const aiInsightsData = useSelector((state: any) => state.aiInsightsData.value);
    const title = useSelector((state: ITitle) => state.title.value);
    const moduleData = useMemo(() => {
        const data = aiInsightsData?.[layoutType];
        const showNoData = data && keys(data)?.length  === 0;
        return {
            data,
            showNoData
        };
    }, [aiInsightsData]);

    return (
        <Row className={`w-100 ${layoutType !== "main" ? "py-0" :"py-3"}`}>
            <Col span={24}>
                <WidgetCard
                    className={`ai-insights-container w-100 ${layoutType !== "main" ? "my-0" : "my-3"}`}  
                >
                    <div className="d-flex align-items-center mb-3">
                        <AiIcon
                            style={{ height: "18px", width: "18px" }}
                        />
                        <div className="d-flex align-items-center gap-2">
                            <h4 className="ai-tab-text mb-0">AI Insights</h4>
                            {
                                showBetaTag(title) &&
                                (
                                    <BetaBadge className="py-1 border border-dark" />
                                )
                            }
                        </div>
                    </div>
                    {isAiInsightsLoading ? (
                        <Skeleton.Node
                            className="w-100"
                            style={{ height: "350px" }}
                            active
                        />
                    ) : moduleData?.showNoData ? (
                        <div
                            className="d-flex align-items-center justify-content-center mt-5"
                            style={{ height: "350px" }}
                        >
                            <NoDataText />
                        </div>
                    ) : (
                        <div className="d-flex flex-column gap-4">
                                    {moduleData?.data?.map((data: any) => (
                                <WidgetCard
                                    key={data.id}
                                    className="shadow-none"
                                >
                                    <h5 className="mb-3">{data?.headline}</h5>

                                    {/* <div className="d-flex align-items-start gap-2 my-3">
                                        <FaBolt
                                            style={{
                                                color: "#faad14",
                                                fontSize: "14px",
                                                marginTop: "2px",
                                                flexShrink: 0,
                                            }}
                                        />
                                        <Text
                                            style={{
                                                color: "#262626",
                                                fontSize: "14px",
                                                lineHeight: "1.5",
                                                fontWeight: 500,
                                            }}
                                        >
                                            <strong>Insight:</strong>{" "}
                                            {data?.insight}
                                        </Text>
                                    </div> */}

                                    {/* Suggestion */}
                                            {/* <div
                                        className="bg-info bg-opacity-10 rounded position-relative p-3 mt-3"
                                        style={{
                                            borderLeft: "6px solid #B3E9FF",
                                        }}
                                    >
                                        <Text
                                            className="text-dark"
                                            style={{
                                                fontSize: "14px",
                                                lineHeight: "1.5",
                                                fontWeight: 500,
                                            }}
                                        >
                                            <strong>Suggestion:</strong>{" "}
                                            {data?.suggestion}
                                        </Text>
                                    </div> */}

                                    {/* Temp UI */}
                                            <div
                                        className="bg-info bg-opacity-10 rounded position-relative p-2 mt-3"
                                        style={{
                                            borderLeft: "6px solid #B3E9FF",
                                        }}
                                    >
                                        <div className="d-flex align-items-start gap-2">
                                        <FaBolt
                                            style={{
                                                color: "#faad14",
                                                fontSize: "14px",
                                                marginTop: "2px",
                                                flexShrink: 0,
                                            }}
                                        />
                                        <Text
                                            style={{
                                                color: "#262626",
                                                fontSize: "14px",
                                                lineHeight: "1.5"
                                            }}
                                        >
                                            <strong>Insight:</strong>{" "}
                                            <span style={{fontWeight: 500}}>{data?.insight}</span>
                                        </Text>
                                    </div>
                                    </div>
                                </WidgetCard>
                            ))}
                        </div>
                    )}
                </WidgetCard>
            </Col>
        </Row>
    );
});

export default RevstackAIInsights;